import React from 'react';
import './CTA.css';

function CTA({ onJoinWaitlist }) {
  const handleWatchDemo = () => {
    window.open('https://youtu.be/nWuITAOiJg8', '_blank');
  };

  return (
    <section className="cta-section" id="contact">
      <h2>Ready to Transform Your Bookkeeping?</h2>
      <p>Join thousands of Indian businesses already using Talkbooks. Start your free trial today!</p>
      <div className="hero-buttons">
        <button className="primary-btn" onClick={onJoinWaitlist}>Join Waitlist</button>
        <button className="secondary-btn" onClick={handleWatchDemo}>Watch Demo</button>
      </div>
    </section>
  );
}

export default CTA;

